angular
  .module('pis-services.module', [])
  .service('stateService', function ($resource, config) {

    const ctrl = this;
    ctrl.selectedWorkspace = 0;
    ctrl.selectedCondition = null;

    const rest = $resource(
      config.api + '',
      {},
      {
        getSimulationLogs: {
          url: config.api + 'pis/simulation-logs',
          method: 'GET',
          isArray: false,
          responseType: 'arraybuffer',
          transformResponse: function (data, headers, statusCode) {
            return {
              response: new Blob([data], { type: 'application/octet-stream' }),
              headers: headers,
              statusCode: statusCode
            };
          }
        },
        getPisLockStatus: {
          url: config.api + 'pis/lock/status',
          method: 'GET',
        },
        lockPisTool: {
          url: config.api + 'pis/lock/set-locked',
          method: 'POST',
          transformResponse: (data, headers, statusCode) => {
            return {
              data: data,
              statusCode: statusCode
            };
          }
        },
        unlockPisTool: {
          url: config.api + 'pis/lock/unlock',
          method: 'POST',
          transformResponse: (data, headers, statusCode) => {
            return {
              data: data,
              statusCode: statusCode
            };
          }
        },
        getWorkspaces: {
          url: config.api + 'pis/workspaces',
          method: 'GET',
          isArray: true,
        },
        createWorkspace: {
          url: config.api + 'pis/workspaces',
          method: 'POST',
        },
        deleteWorkspace: {
          url: config.api + 'pis/workspaces/:id',
          method: 'DELETE',
        },
        editWorkspace: {
          url: config.api + 'pis/workspaces/:id',
          method: 'PUT',
          params: {
            id: '@id',
          },
        },
        editWorkspaceDates: {
          url: config.api + 'pis/workspaces/:id/dates',
          method: 'PUT',
          params: {
            id: '@id',
          },
        },
        setDeployable: {
          url: config.api + 'pis/workspaces/:id/set_deployable',
          method: 'PUT',
          params: {
            id: '@id',
          },
        },
        cancelDeployable: {
          url: config.api + 'pis/workspaces/:id/cancel_deployable',
          method: 'PUT',
          params: {
            id: '@id',
          },
        },
        deployWorkspace: {
          url: config.api + 'pis/workspaces/:id/deploy',
          method: 'POST',
          params: {
            id: '@id',
          },
        },
        publishWorkspace: {
          url: config.api + 'pis/upload/workspaces/:id/publish_workspace',
          method: 'GET',
          params: {
            id: '@id',
          },
          transformResponse: (data, headers, statusCode) => {
            return {
              data: data,
              headers: headers,
              statusCode: statusCode
            };
          }
        },
        cloneWorkspace: {
          url: config.api + 'pis/workspaces/:id/copy',
          method: 'POST',
          params: {
            id: '@id',
          },
        },
        getWorkspaceAudioList: {
          url: config.api + 'pis/workspaces/:id/audio_list',
          method: 'GET',
          params: {
            id: '@id',
          },
        },
        fixWorkspaceAudioFiles: {
          url: config.api + 'pis/workspaces/:id/fragments_fix',
          method: 'PUT',
          params: {
            id: '@id',
          },
        },
        getWorkspaceSegmentStatus: {
          url: config.api + 'pis/workspaces/:id/segment_status',
          method: 'GET',
          params: {
            id: '@id',
          },
          isArray: true,
        },
        getWorkspaceVariables: {
          url: config.api + 'pis/workspaces/:id/environment_variables',
          method: 'GET',
          params: {
            id: '@id',
          },
          isArray: true,
        },
        getSegments: {
          url: config.api + 'pis/segments',
          method: 'GET',
          isArray: true,
        },
        getSegmentAudio: {
          url: config.api + 'pis/segments/:sId/audio/:type',
          method: 'GET',
          params: {
            sId: '@sId',
            type: '@type',
          },
          responseType: 'arraybuffer',
          transformResponse: function (data) {
            return {
              response: new Blob([data], { type: 'audio/mp3' })
            };
          }
        },
        createSegment: {
          url: config.api + 'pis/segments',
          method: 'POST',
          transformResponse: (data, headers, statusCode) => {
            return {
              data: data,
              statusCode: statusCode
            };
          }
        },
        editSegment: {
          url: config.api + 'pis/segments/:sId',
          method: 'PUT',
          params: {
            sId: '@sId',
          },
          transformResponse: (data, headers, statusCode) => {
            return {
              data: data,
              statusCode: statusCode
            };
          }
        },
        deleteSegment: {
          url: config.api + 'pis/segments/:id',
          method: 'DELETE',
          transformResponse: (data, headers, statusCode) => {
            return {
              data: data,
              statusCode: statusCode
            };
          }
        },
        uploadAudio: {
          url: config.api + 'pis/upload/segments/:sId/engine_audio/:type',
          method: 'PUT',
          isArray: false,
          transformRequest: angular.identity,
          transformResponse: (data, headers, statusCode) => {
            return {
              data: data,
              statusCode: statusCode
            };
          },
          params: {
            sId: '@sId',
            type: '@type',
          },
          headers: {
            'Content-Type': undefined,
          },
        },
        uploadOfflineAudio: {
          url: config.api + 'pis/upload/segments/:sId/offline_audio/:number',
          method: 'PUT',
          isArray: false,
          transformRequest: angular.identity,
          transformResponse: (data, headers, statusCode) => {
            return {
              data: data,
              statusCode: statusCode
            };
          },
          params: {
            sId: '@sId',
            number: '@number',
          },
          headers: {
            'Content-Type': undefined,
          },
        },
        getFragments: {
          url: config.api + 'pis/workspaces/:id/fragments_list',
          method: 'GET',
          isArray: true,
        },
        getFragment: {
          url: config.api + 'pis/workspaces/:workspace_id/fragments/:id',
          method: 'GET',
          isArray: false,
        },
        createFragment: {
          url: config.api + 'pis/workspaces/:id/fragments',
          method: 'POST',
          params: {
            id: '@id',
          },
        },
        editFragment: {
          url: config.api + 'pis/workspaces/:id/fragments/:fId',
          method: 'PUT',
          params: {
            id: '@id',
            fId: '@fId',
          },
        },
        deleteFragment: {
          url: config.api + 'pis/workspaces/:id/fragments/:fId',
          method: 'DELETE',
          params: {
            id: '@id',
            fId: '@fId',
          },
        },
        getFragmentTypes: {
          url: config.api + 'pis/workspaces/:id/fragment_types',
          method: 'GET',
          isArray: true,
        },
        getVariables: {
          url: config.api + 'pis/workspaces/:id/variables',
          method: 'GET',
        },
        getConditions: {
          url: config.api + 'pis/workspaces/:id/conditions',
          method: 'GET',
          isArray: true,
        },
        addCondition: {
          url: config.api + 'pis/workspaces/:id/conditions',
          method: 'POST',
          params: {
            id: '@id',
          },
          transformResponse: (data, headers, statusCode) => {
            return {
              data: data,
              statusCode: statusCode
            };
          }
        },
        editCondition: {
          url: config.api + 'pis/workspaces/:id/conditions/:cId',
          method: 'PUT',
          params: {
            id: '@id',
            cId: '@cId',
          },
          transformResponse: (data, headers, statusCode) => {
            return {
              data: data,
              statusCode: statusCode
            };
          }
        },
        reorderConditions: {
          url: config.api + 'pis/workspaces/:id/conditions',
          method: 'PUT',
          params: {
            id: '@id',
          },
        },
        deleteCondition: {
          url: config.api + 'pis/workspaces/:id/conditions/:cId',
          method: 'DELETE',
          params: {
            id: '@id',
            cId: '@cId',
          },
        },
        getTriggers: {
          url: config.api + 'pis/workspaces/:id/triggers',
          method: 'GET',
          isArray: true,
        },
        createTrigger: {
          url: config.api + 'pis/workspaces/:id/triggers',
          method: 'POST',
          params: {
            id: '@id',
          },
        },
        editTrigger: {
          url: config.api + 'pis/workspaces/:id/triggers/:tId',
          method: 'PUT',
          params: {
            id: '@id',
            tId: '@tId',
          },
        },
        deleteTrigger: {
          url: config.api + 'pis/workspaces/:id/triggers/:tId',
          method: 'DELETE',
          params: {
            id: '@id',
            tId: '@tId',
          },
        },
        getStreams: {
          url: config.api + 'pis/workspaces/:id/streams',
          method: 'GET',
          isArray: true,
        },
        createStream: {
          url: config.api + 'pis/workspaces/:id/streams',
          method: 'POST',
          params: {
            id: '@id',
          },
        },
        editStream: {
          url: config.api + 'pis/workspaces/:id/streams/:sId',
          method: 'PUT',
          params: {
            id: '@id',
            sId: '@sId',
          },
        },
        deleteStream: {
          url: config.api + 'pis/workspaces/:id/streams/:sId',
          method: 'DELETE',
          params: {
            id: '@id',
            sId: '@sId',
          },
        },
        getStreamAudio: {
          url: config.api + 'pis/workspaces/:id/streams/:sId/audio',
          method: 'POST',
          params: {
            sId: '@sId',
            id: '@id',
          },
          responseType: 'arraybuffer',
          transformResponse: function (data) {
            return {
              response: new Blob([data], { type: 'audio/mp3' })
            };
          }
        },
        getRunsAndRoutes: {
          url: config.api + 'pis/workspaces/:id/runs_and_routes',
          method: 'GET',
        },
        getRouteMap: {
          url: config.api + 'pis/workspaces/:id/stations/route_map',
          method: 'GET',
        },
        getStations: {
          url: config.api + 'pis/workspaces/:id/stations',
          method: 'GET',
        },
        createStation: {
          url: config.api + 'pis/workspaces/:id/stations',
          method: 'POST',
          params: {
            id: '@id',
          },
        },
        editStation: {
          url: config.api + 'pis/workspaces/:id/stations/:rId',
          method: 'PUT',
          params: {
            id: '@id',
            rId: '@rId',
          },
        },
        deleteStation: {
          url: config.api + 'pis/workspaces/:id/stations/:rId',
          method: 'DELETE',
          params: {
            id: '@id',
            rId: '@rId',
          },
        },
        getTrainNumbers: {
          url: config.api + 'pis/workspaces/:id/train_numbers',
          method: 'GET',
        },
        createTrainNumber: {
          url: config.api + 'pis/workspaces/:id/train_numbers',
          method: 'POST',
          params: {
            id: '@id',
          },
        },
        editTrainNumber: {
          url: config.api + 'pis/workspaces/:id/train_numbers/:tId',
          method: 'PUT',
          params: {
            id: '@id',
            tId: '@tId',
          },
        },
        deleteTrainNumber: {
          url: config.api + 'pis/workspaces/:id/train_numbers/:tId',
          method: 'DELETE',
          params: {
            id: '@id',
            tId: '@tId',
          },
        },
        createRoute: {
          url: config.api + 'pis/workspaces/:id/routes',
          method: 'POST',
          params: {
            id: '@id',
          },
        },
        editRoute: {
          url: config.api + 'pis/workspaces/:id/routes/:rId',
          method: 'PUT',
          params: {
            id: '@id',
            rId: '@rId',
          },
        },
        deleteRoute: {
          url: config.api + 'pis/workspaces/:id/routes/:rId',
          method: 'DELETE',
          params: {
            id: '@id',
            rId: '@rId',
          },
        },
        createRun: {
          url: config.api + 'pis/workspaces/:id/runs',
          method: 'POST',
          params: {
            id: '@id',
          },
        },
        editRun: {
          url: config.api + 'pis/workspaces/:id/runs/:rId',
          method: 'PUT',
          params: {
            id: '@id',
            rId: '@rId',
          },
        },
        deleteRun: {
          url: config.api + 'pis/workspaces/:id/runs/:rId',
          method: 'DELETE',
          params: {
            id: '@id',
            rId: '@rId',
          },
        },
        createVariable: {
          url: config.api + 'pis/workspaces/:id/environment_variables',
          method: 'POST',
          params: {
            id: '@id',
          },
        },
        deleteVariable: {
          url: config.api + 'pis/workspaces/:id/environment_variables/:vId',
          method: 'DELETE',
          params: {
            id: '@id',
            vId: '@vId',
          },
        },
      }
    );

    const getSelectedWorkspace = () => ctrl.selectedWorkspace;

    const setSelectedWorkspace = selectedWorkspace => {
      ctrl.selectedWorkspace = selectedWorkspace;
    };

    const getSelectedCondition = () => ctrl.selectedCondition;

    const setSelectedCondition = selectedCondition => {
      ctrl.selectedCondition = selectedCondition;
    };

    const setAllAudioStation = station => {
      ctrl.allAudioStation = station;
    };

    const getAllAudioStation = () => ctrl.allAudioStation;

    const getStreamTypes = () => STREAM_TYPES;

    const STREAM_TYPES = [
      { id: 1, name: 'TEXT' },
      { id: 2, name: 'AUDIO' },
    ];

    return {
      getSelectedWorkspace,
      setSelectedWorkspace,
      getSelectedCondition,
      setSelectedCondition,
      setAllAudioStation,
      getAllAudioStation,
      getStreamTypes,
      
      getSimulationLogs: () => {
        return rest.getSimulationLogs().$promise;
      },
      getPisLockStatus: () => {
        return rest.getPisLockStatus().$promise;
      },
      lockPisTool: () => {
        return rest.lockPisTool().$promise;
      },
      unlockPisTool: () => {
        return rest.unlockPisTool().$promise;
      },
      getWorkspaces: () => {
        return rest.getWorkspaces().$promise;
      },
      createWorkspace: params => {
        return rest.createWorkspace(params).$promise;
      },
      deleteWorkspace: id => {
        return rest.deleteWorkspace({ id: id }).$promise;
      },
      editWorkspace: params => {
        return rest.editWorkspace(params).$promise;
      },
      editWorkspaceDates: (id, startDate, endDate) => {
        let params = { start_date: startDate, end_date: endDate };
        return rest.editWorkspaceDates({ id: id }, params).$promise;
      },
      setDeployable: id => {
        return rest.setDeployable({ id }).$promise;
      },
      cancelDeployable: id => {
        return rest.cancelDeployable({ id }).$promise;
      },
      deployWorkspace: id => {
        return rest.deployWorkspace({ id }).$promise;
      },
      publishWorkspace: id => {
        return rest.publishWorkspace({ id }).$promise;
      },
      cloneWorkspace: params => {
        return rest.cloneWorkspace(params).$promise;
      },
      getWorkspaceAudioList: id => {
        return rest.getWorkspaceAudioList({ id }).$promise;
      },
      getWorkspaceVariables: id => {
        return rest.getWorkspaceVariables({ id }).$promise;
      },
      fixWorkspaceAudioFiles: id => {
        return rest.fixWorkspaceAudioFiles({ id }).$promise;
      },
      getWorkspaceSegmentStatus: id => {
        return rest.getWorkspaceSegmentStatus({ id }).$promise;
      },
      getSegments: () => {
        return rest.getSegments().$promise;
      },
      getSegmentAudio: (sId, type) => {
        return rest.getSegmentAudio({ sId: sId, type: type }).$promise;
      },
      createSegment: params => {
        return rest.createSegment(params).$promise;
      },
      editSegment: (sId, params) => {
        return rest.editSegment({ sId: sId }, params).$promise;
      },
      deleteSegment: id => {
        return rest.deleteSegment({ id: id }).$promise;
      },
      uploadAudio: (sId, type, obj) => {
        let formdata = new FormData();
        formdata.append('file', obj);
        return rest.uploadAudio({ sId: sId, type: type }, formdata).$promise;
      },
      uploadOfflineAudio: (sId, number, obj) => {
        let formdata = new FormData();
        formdata.append('file', obj);
        return rest.uploadOfflineAudio({ sId: sId, number: number }, formdata).$promise;
      },
      getFragments: id => {
        return rest.getFragments({ id: id }).$promise;
      },
      getFragment: (workspace_id, id) => {
        return rest.getFragment({ workspace_id: workspace_id, id: id }).$promise;
      },
      createFragment: (id, params) => {
        return rest.createFragment({ id: id }, params).$promise;
      },
      editFragment: (id, fId, params) => {
        return rest.editFragment({ id: id, fId: fId }, params).$promise;
      },
      deleteFragment: (id, fId) => {
        return rest.deleteFragment({ id: id, fId: fId }).$promise;
      },
      getFragmentTypes: id => {
        return rest.getFragmentTypes({ id: id }).$promise;
      },
      getVariables: id => {
        return rest.getVariables({ id: id }).$promise;
      },
      getConditions: id => {
        return rest.getConditions({ id: id }).$promise;
      },
      addCondition: (params, id) => {
        return rest.addCondition({ id: id }, params).$promise;
      },
      editCondition: (id, cId, params) => {
        return rest.editCondition({ id: id, cId: cId }, params).$promise;
      },
      reorderConditions: (id, params) => {
        return rest.reorderConditions({ id: id }, params).$promise;
      },
      deleteCondition: (id, cId) => {
        return rest.deleteCondition({ id: id, cId: cId }).$promise;
      },
      getTriggers: id => {
        return rest.getTriggers({ id: id }).$promise;
      },
      createTrigger: (params, id) => {
        return rest.createTrigger({ id: id }, params).$promise;
      },
      editTrigger: (id, tId, params) => {
        return rest.editTrigger({ id: id, tId: tId }, params).$promise;
      },
      deleteTrigger: (id, tId) => {
        return rest.deleteTrigger({ id: id, tId: tId }).$promise;
      },
      createStream: (params, id) => {
        return rest.createStream({ id: id }, params).$promise;
      },
      getStreams: id => {
        return rest.getStreams({ id: id }).$promise;
      },
      editStream: (id, sId, params) => {
        return rest.editStream({ id: id, sId: sId }, params).$promise;
      },
      deleteStream: (id, sId) => {
        return rest.deleteStream({ id: id, sId: sId }).$promise;
      },
      getStreamAudio: (id, sId, macro) => {
        return rest.getStreamAudio({ id: id, sId: sId }, macro).$promise;
      },
      getRunsAndRoutes: id => {
        return rest.getRunsAndRoutes({ id: id }).$promise;
      },
      getRouteMap: id => {
        return rest.getRouteMap({ id: id }).$promise;
      },
      getStations: id => {
        return rest.getStations({ id: id }).$promise;
      },
      createStation: (params, id) => {
        return rest.createStation({ id: id }, params).$promise;
      },
      editStation: (id, rId, params) => {
        return rest.editStation({ id: id, rId: rId }, params).$promise;
      },
      deleteStation: (id, rId) => {
        return rest.deleteStation({ id: id, rId: rId }).$promise;
      },
      initiateSimulation: id => {
        // return rest.initiateSimulation({ id }).$promise;
        return {
          simulator_reports: [
            {
              engine: {
                date: "",
                d_plus: 1.4,
                engVar: [],
                envVar: [],
                macroVar: [],
                toi: [],
              },
              train: {},
              events: [],
              streams: [
                {
                  stream_id: 1,
                  cond_id: 1,
                  trigger_id: 1,
                  trigger_ix: 1,
                  errors_total: 2,
                  types: [],
                  macro_fragments: [],
                  synchronize: false,
                  sentToLine: 0.0,
                  delayed: 0.0,
                  wait: false,
                  wait_ends: 22.3,
                }
              ],
              errors: [],
              info: [],
              changes: [],
              waits: [],
              time: 1.2,
            }
          ],
          logic_packages: {},
          run: 1,
          script_end: "",
          statistics: {}
        };
      },
      getTrainNumbers: id => {
        return rest.getTrainNumbers({ id }).$promise;
      },
      createTrainNumber: (params, id) => {
        return rest.createTrainNumber({ id }, params).$promise;
      },
      editTrainNumber: (id, tId, params) => {
        return rest.editTrainNumber({ id, tId }, params).$promise;
      },
      deleteTrainNumber: (id, tId) => {
        return rest.deleteTrainNumber({ id, tId }).$promise;
      },
      createRoute: (params, id) => {
        return rest.createRoute({ id: id }, params).$promise;
      },
      editRoute: (id, rId, params) => {
        return rest.editRoute({ id: id, rId: rId }, params).$promise;
      },
      deleteRoute: (id, rId) => {
        return rest.deleteRoute({ id: id, rId: rId }).$promise;
      },
      createRun: (params, id) => {
        return rest.createRun({ id: id }, params).$promise;
      },
      editRun: (id, rId, params) => {
        return rest.editRun({ id: id, rId: rId }, params).$promise;
      },
      deleteRun: (id, rId) => {
        return rest.deleteRun({ id: id, rId: rId }).$promise;
      },
      createVariable: (id, params) => {
        return rest.createVariable({id: id}, params).$promise;
      },
      deleteVariable: (id, vId) => {
        return rest.deleteVariable({id: id, vId: vId}).$promise;
      }

    };
  });
